import { Box } from '@material-ui/core';

import { usePreviewStyles } from 'componentsV2/pdf-preview-dialog';

interface AudioContentProps {
  url: string;
}

export const AudioContent = ({ url }: AudioContentProps) => {
  const classes = usePreviewStyles();

  return (
    <Box className={classes.scrollArea}>
      {/* eslint-disable-next-line jsx-a11y/media-has-caption */}
      <audio controls src={url} style={{ margin: 'auto', width: '80%' }} />
    </Box>
  );
};
